import { Form } from "antd";
import styled from "styled-components";

export const FormItem = styled(Form.Item)`
  &.ant-form-item {
    margin-bottom: 0px;
  }
`;
